import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Recuerda qué avisos «de una sola vez» ya ha visto el cliente, persistiendo el
 * estado en `localStorage`. Centraliza el patrón para que los componentes no
 * dupliquen el acceso a storage ni las guardas de SSR.
 *
 * SSR-safe: en el servidor `hasSeen` devuelve `false` (no hay storage) y
 * `markSeen` es un no-op; el efecto real ocurre solo en el navegador.
 */
@Injectable({ providedIn: 'root' })
export class OneTimeNoticeService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  /** True si el aviso `key` ya fue confirmado previamente por el cliente. */
  hasSeen(key: string): boolean {
    if (!this.isBrowser) return false;
    try {
      return localStorage.getItem(key) === '1';
    } catch {
      // localStorage puede lanzar en modo privado/cuota; degradar a «no visto».
      return false;
    }
  }

  /** Marca el aviso `key` como visto para no volver a mostrarlo. */
  markSeen(key: string): void {
    if (!this.isBrowser) return;
    try {
      localStorage.setItem(key, '1');
    } catch {
      // Si el storage no está disponible, el aviso simplemente reaparecerá.
    }
  }
}
